import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { TutorialChapter } from '@il-colpo/engine';
import { Badge, Button, Panel } from '../../ui/index.ts';
import { useGame } from '../GameContext.tsx';
import { useLooseT } from '../text/loose.ts';
import { pickTip } from './tips.ts';
import styles from './Coach.module.css';

/** The Tutorial's coach: one short tip about what is on the screen, dismissible. */
export function Coach({ chapter }: { chapter: TutorialChapter }) {
  const { t } = useTranslation('tutorial');
  const tips = useLooseT('tutorial');
  const { view } = useGame();
  // The tip the player waved away; a different tip shows again by itself.
  const [dismissed, setDismissed] = useState<string | null>(null);
  const key = pickTip(chapter.id, view);
  if (!key) return null;

  if (dismissed === key) {
    return (
      <div className={styles['collapsed']}>
        <Button variant="ghost" size="md" icon="book" onClick={() => setDismissed(null)}>
          {t('coach.show')}
        </Button>
      </div>
    );
  }
  return (
    <Panel tone="blueprint" className={styles['coach']} role="note" aria-label={t('coach.title')}>
      <Badge tone="cyan">{t('coach.title')}</Badge>
      <p className={styles['tip']}>{tips(`tips.${key}`)}</p>
      <Button variant="secondary" size="md" onClick={() => setDismissed(key)}>
        {t('coach.gotIt')}
      </Button>
    </Panel>
  );
}
